module.exports = __webpack_public_path__ + "static/img/invite_btn.70af1c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/new_years_day/invite_btn.png
// module id = qXee
// module chunks = 1